<script>
import { Bar } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';
import { Accent8, Paired12 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.brewer';

export default {
  extends: Bar,
  props: ['chartdata', 'total'],
  data : function() {
    return {
      options : {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            enabled: false
        },
        legend: {
          display: false
        },
        scales : {
          xAxes : [{
            maxBarThickness: 100,
            gridLines : {
                display : false
            }
          }]
        },
        layout : {
          padding : {
            top: 30
          }
        },
        animation : {
          onProgress: function () {
            var chartInstance = this.chart,
            ctx = chartInstance.ctx;
            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            this.data.datasets.forEach(function(dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function(bar, index) {
                var data = dataset.data[index];
                ctx.fillText(data, bar._model.x, bar._model.y);
              });
            });
          }
        }
      },
    }
  },
  mounted () {
    let total = 'total';
    if (this.total) {
      total = this.total
    }
    const chartData = {
      datasets: [{
        backgroundColor : Paired12.concat(Accent8).map(item=>{ return this.hexToRgb(item, 0.6) }),
        borderColor : Paired12.concat(Accent8),
        borderWidth: 1,
        data: Object.entries(this.chartdata).map(item => { return item[1][total] })
      }],
      labels : Object.entries(this.chartdata).map(item => { return item[1].name })
    };
    this.renderChart(chartData, this.options);
  },
  methods: {
    hexToRgb: function(hex, alpha) {
      alpha = alpha ? alpha : 1
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? 'rgba('+parseInt(result[1], 16)+', '+parseInt(result[2], 16)+', '+parseInt(result[3], 16)+', '+alpha+')' : null;
    }
  }
}
</script>

<style>
</style>